import axios from "axios";
import { useState } from "react";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { GlobalState } from "../../../context/GlobalContext";
import { modifyExcel } from "utils/Excels/excelTemplateCOFO";
import { FRANCHISE_FIELDS, FRANCHISE_MAPPING } from "../data";
import { getColDefaultValue } from "components/EboStoreV4/data";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import { grey } from "@mui/material/colors";

const COFOPaymentWorking = () => {
	const defFields = (() => {
		let obj = {};
		FRANCHISE_FIELDS?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	})();
	const [data, setData] = useState(defFields);
	const [result, setResult] = useState();
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const columns = [
		{
			field: "MONTH",
			headerName: "Month",
			width: 90,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "STORE_NAME",
			headerName: "Store Name",
			width: 350,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "BILL_QUANTITY",
			headerName: "Quantity",
			width: 120,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "MRP_VALUE",
			headerName: "MRP Sales",
			width: 120,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "TOTAL_DISCOUNT",
			headerName: "Discount",
			width: 120,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "DISCOUNT_PERCENT",
			headerName: "Discount %",
			width: 130,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "REALISED_VALUE",
			headerName: "Realised Value",
			width: 110,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "COMISSION_RATE",
			headerName: "Commission %",
			width: 150,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "COMISSION_VALUE",
			headerName: "Commission Value",
			width: 150,
			align: "center",
			headerAlign: "center",
		},
	];

	function getMonthRange(start, end) {
		const startDate = new Date(start);
		const endDate = new Date(end);

		const formatMonthYear = (date) => {
			const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase();
			const year = date.getFullYear().toString().slice(-2);
			return `${month}'${year}`;
		};

		const startFormatted = formatMonthYear(startDate);
		const endFormatted = formatMonthYear(endDate);

		return startFormatted === endFormatted ? startFormatted : `${startFormatted} - ${endFormatted}`;
	}

	const handleRun = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/cofo_payment_working/${data?.franchise}?startDate="${data?.start_date}"&endDate="${data?.end_date}"`,
				method: "GET",
			}).then((res) => {
				setResult(res.data);
				setLoadingOpen(false);
			});
		} catch (error) {
			setLoadingOpen(false);
			if (error.response)
				if (error.response.status === 404)
					setSnackBar({
						...snackBar,
						message: "No mismatch records were found",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				else
					setSnackBar({
						...snackBar,
						message: "Internal Server Error",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
			else
				setSnackBar({
					...snackBar,
					message: "Error :Download Failed",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			setSnackBarOpen(true);
		}
	};

	const handleDownload = () => {
		const headerData = getMonthRange(data?.start_date, data?.end_date);
		modifyExcel(result, FRANCHISE_MAPPING[data?.franchise], headerData, data?.franchise);
	};

	return (
		<Box display="flex" flexWrap="wrap" alignItems="flex-end" columnGap="15px" rowGap="10px" width="100%" pt={4}>
			{/* Row of input fields + button */}

			{FRANCHISE_FIELDS?.map((row) => (
				<RenderInputField
					key={row.key} // assume unique id
					column={row}
					data={data}
					setData={setData}
					width="24%"
					selectOptObjName="option_data"
				/>
			))}
			<Box pb={1}>
				<Button variant="contained" onClick={handleRun}>
					Run
				</Button>
			</Box>

			{/* DataGrid with Download Button */}
			{result && (
				<Box width="100%">
					<Stack mb={1} spacing={1}>
						<Box alignSelf={"flex-end"}>
							<Button variant="contained" onClick={handleDownload}>
								Download
							</Button>
						</Box>
						<DataGrid
							rows={result}
							columns={columns}
							getRowId={(row) => row.STORE_NAME}
							sx={{
								width: "100%",
								border: "none",
								"& .MuiDataGrid-row": {
									// borderBottom: "1px solid lightgray",
									cursor: "pointer",
									border: "none",
								},
								"& .MuiDataGrid-cell": {
									// borderBottom: "1px solid lightgray",
									padding: 0,
								},
								"& .MuiDataGrid-columnHeader": {
									cursor: "pointer",
									background: grey[300],
								},
							}}
							columnHeaderHeight={35}
							rowHeight={40}
							disableAutosize
							disableRowSelectionOnClick
						/>
					</Stack>
				</Box>
			)}
		</Box>
	);
};

export default COFOPaymentWorking;
